module.exports = __webpack_public_path__ + "static/cogs-184c71763c3df069ee874e25d5439413.svg";